<template>
    <div class="meals-evaluation-wrapper">
        <div class="evaluation-title-wrapper">
            <strong class="evaluation-title">{{ __('Rating') }}</strong>
            <div class="evaluation-value">
                {{ evaluationTotal }}
                <span>/10</span>
            </div>
            <p>{{ __choice('{1} Record for 1 month of treatment|[2,4] Record for :months months of treatment|[5,*] Record for :months months of treatment', patientCurrentMonth, { months: patientCurrentMonth }) }}</p>
        </div>
        <div class="evaluation-months">
            <div class="evaluation-graph-legend">
                <span class="legend-top">10</span>
                <span class="legend-middle">5</span>
                <span class="legend-bottom">0</span>
            </div>

            <div v-for="month in patientCurrentMonth" :key="month" class="evaluation-month">
                <span class="evaluation-month-title">{{ __('month') }} {{ month }}</span>
                <div class="evaluation-weeks">
                    <template v-for="week in 4">
                        <a
                            v-if="!isWeekInFuture(getWeekDate(week, month))"
                            :key="week"
                            href="#"
                            :class="['evaluation-week', { 'current-week': isCurrentWeek(getWeekDate(week, month)) }]"
                            @click.prevent="changeWeek(getWeekDate(week, month))"
                        >
                            <div :class="'evaluation-week-graph value-' + getWeekEvaluationValue(month, week)"></div>
                            <div class="evaluation-week-value">
                                {{ getWeekEvaluationValue(month, week) == 0 ? '-' : getWeekEvaluationValue(month, week) }}
                            </div>
                        </a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            weekDate: {
                type: String,
                required: true
            },
            mealsEvaluation: {
                type: Object,
                required: false
            },
            patientProgrammeStart: {
                type: String,
                required: true
            },
            patientCurrentMonth: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                currentDate: moment().format('YYYY-MM-DD')
            }
        },
        computed: {
            evaluationTotal() {
                if (this.mealsEvaluation.all) {
                    return Math.round(this.mealsEvaluation.all)
                } else {
                    return 0
                }
            }
        },
        methods: {
            getWeekDate(week, month) {
                return moment(this.patientProgrammeStart)
                    .add(week + (month * 4 - 5), 'week')
                    .format('YYYY-MM-DD')
            },
            getWeekEvaluationValue(month, week) {
                if (this.mealsEvaluation.all 
                    && this.mealsEvaluation.weeks[month]
                    && this.mealsEvaluation.weeks[month][week - 1] 
                    && this.mealsEvaluation.weeks[month][week - 1].evaluation) {
                    return Math.round(this.mealsEvaluation.weeks[month][week - 1].evaluation)
                } else {
                    return 0
                }
            },
            isCurrentWeek(date) {
                if (moment(this.weekDate).startOf('isoWeek').format('YYYY-MM-DD').toString() === date) {
                    return true
                }

                return false
            },
            isWeekInFuture(date) {
                if (date > this.currentDate) {
                    return true
                }

                return false
            },
            changeWeek(date) {
                this.$emit("weekChange", date)
            }
        }
    }
</script>
